import { render, staticRenderFns } from "./BonusMilesIcon.vue?vue&type=template&id=64059454&"
import script from "./BonusMilesIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BonusMilesIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports